export default __webpack_public_path__ + "static/media/Vehicle-Detection.920b4228.jpg";